import React, { useState, useEffect, useContext } from "react";
import {
  Row,
  Col,
  Card,
  message,
  Divider,
  Space,
  Button,
  Modal,
  Typography,
  Tag,
  Form,
  Input,
  Checkbox,
  InputNumber,
} from "antd";
import { FileDoneOutlined, LockOutlined, EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { RenderPdf } from "../../../components/renderPdf";
import http from "../../../services/http";
import dayjs from "dayjs";
import { AuthContext } from "../../../contexts/AuthContext";
import { listarPendencias } from "../../../helpers/pendencias";
import { parseToInt, randomInt } from "../../../helpers/masks";
const { Text } = Typography;

const validator = {
  confirmacao: [
    {
      validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error("Marque esta opção!"))),
    },
  ],
  operacao_matematica: [{ required: true, message: "Digite a resposta!" }],
};

export const AceitesDocumentosDetalhes = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [firstNumber] = useState(randomInt(9));
  const [secondNumber] = useState(randomInt(9));
  const { id_aceites_documentos } = useParams();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState({});
  const [modal, contextHolder] = Modal.useModal();
  const [arquivo, setArquivo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { atualizarPendencias } = useContext(AuthContext);

  useEffect(() => {
    if (id_aceites_documentos) {
      carregarAceitesDocumentos(id_aceites_documentos);
      carregarAceitesDocumentosDocumento(id_aceites_documentos);
    }
  }, [id_aceites_documentos]);

  // LISTAR
  const carregarAceitesDocumentos = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/aceites_documentos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        navigate("/aceites-documentos");
      }

      if (api?.response?.data?.status_confirmacao === 0) {
        modal.info({
          title: "Atenção",
          content: "Verifique se os dados presentes estão corretos e confirme o recebimento do documento.",
          onOk() {},
        });
      }
      setDados(api.response.data);
    } else {
      navigate("/aceites-documentos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR DOCUMENTO
  const carregarAceitesDocumentosDocumento = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/aceites_documentos/carregar_documento/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        navigate("/aceites-documentos");
      }

      // CRIAR ARQUIVO PDF
      var blob = new Blob([api.response.data], {
        type: "application/pdf",
      });
      const url = window.URL.createObjectURL(blob);
      setArquivo(url);
    } else {
      navigate("/aceites-documentos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CONFIRMAR
  const confirmarAceitesDocumentos = async (formulario) => {
    if (dados.status_confirmacao === 1) {
      message.error("Documento já confirmado!");
      setShowModal(false);
      form.resetFields();
      return;
    }
    setLoading(true);
    const api = await http("post", `v2/aceites_documentos/confirmar`, formulario);
    if (api.statusCode === 200) {
      setShowModal(false);
      form.resetFields();
      carregarAceitesDocumentos(id_aceites_documentos);
      message.success("Documento confirmado com sucesso!");

      // ATUALIZAR PENDÊNCIAS
      listarPendencias(atualizarPendencias);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (firstNumber + secondNumber !== parseToInt(formulario?.operacao_matematica)) {
      form.setFields([
        {
          name: "operacao_matematica",
          errors: ["Resultado incorreto!"],
        },
      ]);
      return;
    }

    confirmarAceitesDocumentos({
      id: id_aceites_documentos,
      operacao_matematica: `${firstNumber} + ${secondNumber} = ${parseToInt(formulario?.operacao_matematica)}`,
      senha: formulario?.senha,
    });
  };

  // FORMULÁRIO
  const modalFormulario = (
    <Modal
      title={"Formulário de Aceite de Documento"}
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={600}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        form.resetFields();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <Form.Item name="confirmacao" valuePropName="checked" rules={validator?.confirmacao}>
              <Checkbox disabled={loading}>
                Declaro que li e concordo com as informações contidas no documento.
              </Checkbox>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={24}>
            <Form.Item
              name="operacao_matematica"
              label="Resolva a Operação Matemática"
              rules={validator?.operacao_matematica}>
              <Space>
                <Text style={{ fontSize: 20 }}>
                  {firstNumber} + {secondNumber} ={" "}
                </Text>
                <InputNumber
                  controls={false}
                  autoComplete="off"
                  className="input-number"
                  precision={0}
                  min={0}
                  style={{ width: 100 }}
                  size="large"
                  disabled={loading}
                  placeholder="..."
                />
              </Space>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={24}>
            <Form.Item
              className="FormItem"
              label="Senha de acesso do portal do colaborador"
              name="senha"
              rules={[{ required: true, message: "Digite sua senha!" }]}>
              <Input.Password
                size="large"
                autoComplete="off"
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="Digite sua senha de uso pessoal e instranferível"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                disabled={loading}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
        <div className="content-item">
          <HeaderPage title="Documentos" onClickBack={() => navigate("/aceites-documentos")} />
          <HeaderTitle
            title="Aceites de Documentos"
            loading={loading}
            subtitle={dados?.tipo}
            icon={<FileDoneOutlined />}
          />
          <Divider />
          <Card bordered={false} bodyStyle={{ padding: "3%" }}>
            <Space wrap size={20}>
              {dados?.status_confirmacao === 0 && (
                <Button onClick={() => setShowModal(true)} size="large" type="primary">
                  Confirmar
                </Button>
              )}
              <Space direction="vertical" size={0}>
                <Text style={{ fontSize: 12 }} type="secondary">
                  Tipo:
                </Text>
                <Text style={{ fontSize: 14 }} strong>
                  {dados?.tipo}
                </Text>
              </Space>

              <Space direction="vertical" size={0}>
                <Text style={{ fontSize: 12 }} type="secondary">
                  Data:
                </Text>
                <Text style={{ fontSize: 14 }} strong>
                  {dayjs(dados?.data_lancamento).format("DD/MM/YYYY")}
                </Text>
              </Space>

              <Space direction="vertical" size={0}>
                <Text style={{ fontSize: 12 }} type="secondary">
                  Status Confirmação:
                </Text>
                <Text style={{ fontSize: 14 }} strong>
                  {dados?.status_confirmacao === 1 ? (
                    <Tag color="green">Confirmado</Tag>
                  ) : (
                    <Tag color="red">Pendente</Tag>
                  )}
                </Text>
              </Space>
            </Space>

            <Divider />
            <RenderPdf file={arquivo} />
          </Card>
        </div>
      </Col>
      {contextHolder}
    </Row>
  );
};
